var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.series.length)?_c('VueApexCharts',{attrs:{"id":"bar-chart","type":"bar","height":"350","options":_vm.chartOptions,"series":_vm.series}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }